import { render, staticRenderFns } from "./ModalSurvivalStatsValues.vue?vue&type=template&id=20fc26c2&scoped=true"
import script from "./ModalSurvivalStatsValues.vue?vue&type=script&lang=js"
export * from "./ModalSurvivalStatsValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fc26c2",
  null
  
)

export default component.exports